<template>
  <BaseTable :name='name' :getDataAction='getDataAction' :tableColumns='tableColumns' :isShowCloseBtn='isShowCloseBtn' @SizeChange='sizeChange' @StateChange='stateChange'></BaseTable>
</template>


<script>
import {
  GetPurchaseFinishStatus
} from '@/api'
import BaseTable from './../baseTable.vue'

export default ({
  // mixins: [BaseReportMixin],
  components: {
    BaseTable
  },
  data () {
    return {
      getDataAction: GetPurchaseFinishStatus,
      tableColumns: [
        {
          no: 'createdTime',
          name: '日期',
          width: 80,
          type: 'date',
          dateFormatter: '{y}-{m}-{d}'
        },
        {
          no: 'no',
          name: '单号',
          width: 120,
          type: 'text',
        },
        {
          no: 'supplierName',
          name: '供应商',
          width: 100,
          type: 'text',
        },
        // {
        //   no: 'specName',
        //   name: '规格型号',
        //   width: 100,
        //   type: 'text',
        // },
        // {
        //   no: 'manufacturerName',
        //   name: '生产厂家',
        //   width: 100,
        //   type: 'text',
        // },
        {
          no: 'orderNumber',
          name: '接单数量',
          width: 60,
          type: 'text',
        },
        {
          no: 'finishNumber',
          name: '已完成数量',
          width: 60,
          type: 'text',
        },
        {
          no: 'status',
          name: '完成情况',
          width: 80,
          type: 'progress',
          number: 'finishNumber',
          totalNumber: 'orderNumber'
        },

      ],
      // myChart: null,
      // option: {},
      // tableData: [],
      // allData: [],
      // show: true,
      // totalPage: 0,
      // pageSize: 5,
      // pageIndex: 1,
      // interval: 5 * 1000,
      // setInterval: null
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
    // data: {
    //   handler (newVal, oldVal) {
    //     this.option.series[0].data = newVal
    //     if (!this.myChart) {
    //       this.myChart = this.$echarts.init(this.$refs['myChart'])
    //     }
    //     this.myChart.setOption(this.option);
    //   },
    //   deep: true
    // }
  },
  methods: {

    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },
  },
  mounted () {
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
  },
  beforeDestroy () {
    // clearInterval(this.setInterval)
  },
})
</script>
<style scoped lang="scss">
</style>
